export default __webpack_public_path__ + "static/media/xiaohui_medical_consultant.eda90a00.png";